module.exports = __webpack_public_path__ + "img/3-bg.9c3ad000.png";